import { render } from "./ClassIndexView.vue?vue&type=template&id=7cdd0498"
import script from "./ClassIndexView.vue?vue&type=script&lang=js"
export * from "./ClassIndexView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__